import Home from "js/pages/Home";
import NotFound from "js/pages/NotFound";
import Forbidden from "js/pages/Forbidden";
import Privacy from "js/pages/Privacy";
import Cookies from "js/pages/Cookies";
import Contact from "js/pages/Contact";
import Register from "js/pages/users/Register";
import Login from "js/pages/users/Login";
import Verify from "js/pages/users/Verify";
import PasswordReset from "js/pages/users/PasswordReset";
import PasswordForgot from "js/pages/users/PasswordForgot";
import Settings from "js/pages/users/Settings";
import Notifications from "js/pages/users/Notifications";
import Friends from "js/pages/users/Friends";
import Unsubscribe from "js/pages/users/Unsubscribe";
import UserData from "js/pages/UserData";
import TripInspirations from "js/pages/planning/TripInspirations";
import SavedIdeas from "js/pages/planning/SavedIdeas";
import TravelSchedule from "js/pages/planning/TravelSchedule";

// Landing page
import LandingPage from "js/pages/landing-page/LandingPage";

// Trips
import TripList from "js/pages/trips/List";
import TripView from "js/pages/trips/View";
import TripAdd from "js/pages/trips/Add";
import TripEdit from "js/pages/trips/Edit";

// Locations
import LocationAdd from "js/pages/locations/Add";
import LocationEdit from "js/pages/locations/Edit";

// Bucket lists
import BucketListList from "js/pages/bucket-lists/List";
import BucketListView from "js/pages/bucket-lists/View";
import BucketListAdd from "js/pages/bucket-lists/Add";
import BucketListEdit from "js/pages/bucket-lists/Edit";

// Stats
import Stats from "js/pages/stats/Stats";
import StatsYoY from "js/pages/stats/Yoy";
import StatsCountries from "js/pages/stats/Countries";
import StatsPlaces from "js/pages/stats/Places";
import StatsTrips from "js/pages/stats/Trips";
import StatsBucketLists from "js/pages/stats/BucketLists";
import StatsTransport from "js/pages/stats/Transport";
import StatsCompanions from "js/pages/stats/Companions";
import { ACCESS } from "js/router/guard.js";

const MIN_YEAR = 1900;
const MAX_YEAR = 3000;

const routes = [
    {
        name: "home",
        title: "Home",
        path: "/",
        component: Home,
    },
    {
        name: "landingPage",
        path: "/welcome",
        component: LandingPage,
        meta: { access: ACCESS.PUBLIC },
    },
    // Profile
    {
        name: "register",
        path: "/register",
        component: Register,
        meta: { access: ACCESS.GUEST },
    },
    {
        name: "login",
        path: "/login",
        component: Login,
        meta: { access: ACCESS.GUEST },
    },
    {
        name: "verify",
        path: "/verify",
        component: Verify,
        meta: { access: ACCESS.UNVERIFIED },
    },
    {
        name: "passwordReset",
        path: "/reset-password/:token",
        component: PasswordReset,
        meta: { access: ACCESS.GUEST },
    },
    {
        name: "passwordForgot",
        path: "/forgot-password",
        component: PasswordForgot,
        meta: { access: ACCESS.GUEST },
    },
    {
        name: "settings",
        path: "/settings",
        component: Settings,
    },
    {
        name: "userNotifications",
        title: "Notifications",
        path: "/users/notifications",
        component: Notifications,
    },
    {
        name: "friends",
        title: "Friends",
        path: "/users/friends",
        component: Friends,
    },
    {
        name: "unsubscribe",
        path: "/unsubscribe/:user",
        component: Unsubscribe,
        meta: { access: ACCESS.PUBLIC },
    },
    {
        name: "userData",
        path: "/users/data",
        component: UserData,
    },
    // Trips
    {
        name: "tripList",
        title: "Trips",
        path: "/trips",
        component: TripList,
    },
    {
        name: "tripAdd",
        path: "/trips/add",
        component: TripAdd,
    },
    {
        name: "tripView",
        path: "/trips/:id",
        component: TripView,
    },
    {
        name: "tripEdit",
        path: "/trips/:id/edit",
        component: TripEdit,
    },
    // Locations
    {
        name: "locationAdd",
        path: "/trips/:tripId/locations/add",
        component: LocationAdd,
    },
    {
        name: "locationEdit",
        path: "/trips/:tripId/locations/:id/edit",
        component: LocationEdit,
    },
    // Bucket lists
    {
        name: "bucketListList",
        title: "Bucket lists",
        path: "/bucket-lists",
        component: BucketListList,
    },
    {
        name: "bucketListView",
        path: "/bucket-lists/:id",
        component: BucketListView,
    },
    {
        name: "bucketListAdd",
        path: "/bucket-lists/add",
        component: BucketListAdd,
    },
    {
        name: "bucketListEdit",
        path: "/bucket-lists/:id/edit",
        component: BucketListEdit,
    },
    // Stats
    {
        name: "stats",
        title: "Stats",
        path: "/stats",
        component: Stats,
    },
    {
        name: "statsYearly",
        title: "Yearly stats",
        path: "/stats/yoy",
        component: StatsYoY,
    },
    {
        name: "statsCountries",
        title: "Countries",
        path: "/stats/countries",
        component: StatsCountries,
    },
    {
        name: "statsPlaces",
        title: "Places",
        path: "/stats/places",
        component: StatsPlaces,
    },
    {
        name: "statsTrips",
        title: "Trips",
        path: "/stats/trips",
        component: StatsTrips,
    },
    {
        name: "statsBucketLists",
        title: "Bucket Lists",
        path: "/stats/bucket-lists",
        component: StatsBucketLists,
    },
    {
        name: "statsTransport",
        title: "Transport",
        path: "/stats/transport",
        component: StatsTransport,
    },
    {
        name: "statsCompanions",
        title: "Companions",
        path: "/stats/companions",
        component: StatsCompanions,
    },
    // Planning
    {
        name: "tripPlanning",
        title: "Inspirations",
        path: "/planning",
        component: TripInspirations,
    },
    {
        name: "savedIdeas",
        title: "Saved Ideas",
        path: "/planning/saved",
        component: SavedIdeas,
    },
    {
        name: "travelScheduleCurrent",
        title: "Travel Schedule",
        path: "/planning/schedule",
        redirect: () => `/planning/schedule/${new Date().getFullYear()}`,
    },
    {
        name: "travelSchedule",
        path: "/planning/schedule/:year",
        meta: { menuPath: "/planning/schedule" },
        component: TravelSchedule,
        beforeEnter: (to, from, next) => {
            const year = Number(to.params.year);
            if (!Number.isInteger(year) || year < MIN_YEAR || year > MAX_YEAR) {
                next(`/planning/schedule/${new Date().getFullYear()}`);
            } else {
                next();
            }
        },
    },
    // Static / error pages
    {
        name: "privacy",
        title: "Privacy",
        path: "/privacy",
        component: Privacy,
        meta: { access: ACCESS.PUBLIC },
    },
    {
        name: "cookies",
        title: "Cookies",
        path: "/cookies",
        component: Cookies,
        meta: { access: ACCESS.PUBLIC },
    },
    {
        name: "contact",
        title: "Contact",
        path: "/contact",
        component: Contact,
        meta: { access: ACCESS.PUBLIC },
    },
    {
        name: "forbidden",
        path: "/403",
        component: Forbidden,
        meta: { access: ACCESS.PUBLIC },
    },
    {
        name: "notFound",
        path: "/404",
        component: NotFound,
        meta: { access: ACCESS.PUBLIC },
    },
    {
        name: "catchAll",
        path: "/:pathMatch(.*)*",
        component: NotFound,
        meta: { access: ACCESS.PUBLIC },
    },
];

export default routes;
